<template>
  <main id="radio-player">
      <div class="row">
          <div class="offset-sm-1 col-3 col-md-1 col-sm-4">
              <div id="play-button" @click="isPlaying=!isPlaying">
                <i v-if="isPlaying" class="fa fa-2x fa-pause" ></i>
                <i v-if="!isPlaying" class="fa fa-2x fa-play" ></i>
              </div>
          </div>
          <div class="col">
              <h5 class="d-block d-sm-none text-white">Radio <br> La Senda Antigua</h5>

              <h3 class="d-none d-sm-block text-white">Radio La Senda Antigua</h3>
              <h6 class="d-none d-sm-block text-light" style="font-weight:normal">Transmisión ininterrumpida las 24 horas.</h6>

              <!-- <audio src="https://play10.tikast.com/proxy/lasenda?mp=/stream" ></audio> -->
          </div>
          <div class="col text-left d-none d-sm-block" v-if="isPlaying">              
              <br>
              <img style="max-height:3rem" src="https://www.tecnicomac.cl/audiofest/static/ondas.gif" alt="">              
              <img style="margin-left:-12px; max-height:3rem" src="https://www.tecnicomac.cl/audiofest/static/ondas.gif" alt="">              
          </div>
      </div>
  </main>
</template>

<script>
export default {
    data(){
        return {
            isPlaying:false,
            audio: null,
            secureUrl: "https://play10.tikast.com/proxy/lasenda?mp=/stream",
            standarUrl: "http://163.172.198.16:8010/stream?type=http&nocache=37634"
        }
    },
    watch:{
        isPlaying : function(val){
            if (val) {
                const url = window.location.href                
                if (url.indexOf("https://") != -1) {
                    this.audio = new Audio(this.secureUrl)                    
                } else {
                    this.audio = new Audio(this.standarUrl)                                        
                }

                this.audio.play()
            } else {
                this.audio.pause()
            }
        }
    }
}
</script>

<style>
#radio-player{
    position: fixed;
    bottom: 0;
    height: auto;
    background:#000;
    color: #eee;
    z-index: 9990 !important;
    width: 100%;
    padding:1rem;
}

#play-button{   
    background: #111;
    border: solid 1px #ac8a74;
    width:4rem;
    height: 4rem;
    text-align: center;
    border-radius: 50%;
    padding-top: 1rem;
    cursor: pointer;

    transition: all 500ms;
}

#play-button:hover{
    background: #ac8a74;
    color: #000;
}
</style>